/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

export class VehicleListMeta {
  totalSize: number | undefined = undefined;

  constructor() {
    this.totalSize = 0;
  }
}
